export const tokens = {
  color: {
    primary: '#2E83F4',
    primaryDark: '#1766CC',
    accent: '#E96244',
    background: '#F5F8FC',
    surface: '#FFFFFF',
    text: '#1C2026',
    textMuted: '#6A778A',
  },
  radius: {
    sm: 8,
    md: 14,
    lg: 24,
  },
  space: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },
} as const;
